import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '../Button';
import { Dialog, DialogTitle, DialogContent } from '../Dialog';
import Video from '../Video';

const VideoDialog = ({ handleClose, styleName, video = '' }) => {
  return (
    <Dialog
      open
      onClose={handleClose}
      modalStyle={classNames(styleName.wrapper)}
    >
      <DialogTitle className={classNames(styleName.title)} component="div">
        <Button
          className={classNames(styleName.closeButton)}
          onClick={handleClose}
        >
          <span className={styleName.closeButtonIcon}>&times;</span>
        </Button>
      </DialogTitle>
      <div>
        <DialogContent className={classNames(styleName.content)}>
          <Video src={video} className={classNames(styleName.iframeWrapper)} />
        </DialogContent>
      </div>
    </Dialog>
  );
};

VideoDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  styleName: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.shape({
      wrapper: PropTypes.string,
      title: PropTypes.string,
      closeButton: PropTypes.string,
      closeButtonIcon: PropTypes.string,
      content: PropTypes.string,
      iframeWrapper: PropTypes.string,
    }),
  ]).isRequired,
  video: PropTypes.string,
};


export default VideoDialog;
